<template>
  <nav>
    <HeaderItem/>
  </nav>
  <main class="route-host">
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </main>
  <AccessibilityPanel />
</template>
<script>
import HeaderItem from './components/01main/HeaderItem.vue';
import AccessibilityPanel from './accessibility/AccessibilityPanel.vue';
export default {
  components: {
    HeaderItem,
    AccessibilityPanel
  },
  watch: {
    // When the UI language changes, re-pull DB content so it comes back in the
    // newly selected locale.
    '$i18n.locale'() {
      this.$store.dispatch('refetchAll')
    }
  },
  mounted() {
    // ⚠️ DO NOT REMOVE — scroll-to-top-on-refresh (1 of 3).
    // On a hard refresh / deep link the router's scrollBehavior doesn't always
    // fire, so we force the top here as a belt-and-braces fallback. This works
    // together with `history.scrollRestoration = 'manual'` (main.js) and the
    // `isFreshLoad` branch in router/index.js. Removing any one of the three
    // brings back "refresh keeps the old scroll position" — leave it alone.
    this.$nextTick(() => window.scrollTo(0, 0))
  }
}
</script>
<style lang="scss">
/* White canvas behind the routed pages, capped to the 1920px design width so
   ultra-wide screens keep their navy <body> gutters. This is what a page fades
   over during a transition, and what shows while a lazy-loaded / data-fetching
   page is still mounting — so navigation never flashes the dark navy <body>. */
.route-host {
  max-width: 1920px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
}

/* Page transition between routes: fade + gentle vertical slide.
   With <transition mode="out-in"> the old page fades up and out, then the new
   one slides up into place — so navigating the side-nav (Faoliyat sub-pages)
   and any other page change animates clearly. Disabled for reduced-motion. */
.page-enter-active { transition: opacity .35s ease, transform .35s cubic-bezier(.22, .61, .36, 1); }
.page-leave-active { transition: opacity .2s ease, transform .2s ease; }
.page-enter-from { opacity: 0; transform: translateY(18px); }
.page-leave-to   { opacity: 0; transform: translateY(-12px); }

@media (prefers-reduced-motion: reduce) {
  .page-enter-active,
  .page-leave-active { transition: none; }
  .page-enter-from,
  .page-leave-to { opacity: 1; transform: none; }
}
</style>
